import GoogleIcon from '@mui/icons-material/Google';
import { LoadingButton } from '@mui/lab';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useAsyncConnectGoogleAuth from '../../../../hooks/useAsyncConnectGoogleAuth';
import useLoadGsiScript from '../../../../hooks/useLoadGsiScript';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { GoogleCodeResponse } from '../../../../sic-lib/types/GoogleAuth';
import { sha256 } from '../../../../sic-lib/utils/cryptoHelpers';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { createToast } from '../../../../store/notify';
import { requestConfig } from '../../../../store/users';
import { createErrorToast } from '../../../../utils/notifyHelpers';

export default function ConnectGoogleAccount() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const clientId = useAppSelector(state => state.user.clientId);
    const userName = useAppSelector(state => state.user.userName);

    const loaded = useLoadGsiScript();
    const googleClientRef = React.useRef<any>();
    const [loginHash, setLoginHash] = React.useState<string>('');
    const { asyncAuthorizeWithCodeResponse, requestStatus, responseBody } =
        useAsyncConnectGoogleAuth();

    React.useEffect(() => {
        async function setSha() {
            const state = await sha256(`${clientId}:${userName}`);
            setLoginHash(state);
        }
        setSha();
    }, [clientId, userName]);

    //initialize the google js client
    React.useEffect(() => {
        if (!loaded) return;

        googleClientRef.current = (window as any).google?.accounts.oauth2.initCodeClient({
            client_id: (window as any).googleClientId,
            scope: (window as any).googleScopes,
            callback: handleCodeResponse,
            state: loginHash,
        });
    }, [loginHash, loaded]);

    //trigger the signin consent flow (popup)
    const handleSignIn = () => {
        console.log('handleSignIn');
        if (googleClientRef.current) {
            googleClientRef.current.requestCode();
        } else {
            const toastData = createErrorToast(
                'Could not attempt Sign In. Please try again later.',
            );
            dispatch(createToast({ toastData }));
        }
    };

    const handleCodeResponse = async (codeResponse: GoogleCodeResponse) => {
        console.log('handleGoogleSignIn', codeResponse);

        await asyncAuthorizeWithCodeResponse(codeResponse);

        dispatch(requestConfig());
    };

    return (
        <>
            <LoadingButton
                startIcon={<GoogleIcon />}
                onClick={handleSignIn}
                loadingPosition="start"
                variant="outlined"
                loading={requestStatus == RequestStatus.active}
            >
                Sign in with Google
            </LoadingButton>
            {!!responseBody && (
                <Typography component="p" variant="body2">
                    {responseBody}
                </Typography>
            )}
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
